module.exports = __webpack_public_path__ + "img/product-7.dc2af52d.jpg";